module.exports = __webpack_public_path__ + "static/media/main.836eab2c.png";